module.exports = __webpack_public_path__ + "site/img/about.8deac346.jpg";